// Exports
export default {
	"root": "root_Wrmp8"
};
